import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';

class ProjectServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }
  getList(params) {
    return super.getList({ type: 'pbx', ...params });
  }
  createItem(params) {
    return this.pure_http.post('/projects/numbers', params);
  }
  getItem(id) {
    return this.http.get(`/${id}`);
  }
  editItem(id, params = {}) {
    return this.http.put(`/${id}`, params);
  }
}

export const ProjectService = new ProjectServiceClass({
  api_version: 1,
  resource: 'projects'
});
